import { MenuItemType } from '../../../utils/types'
import { WContainer } from '../../atoms'
import { ArticoloCard } from '../../molecules'
import styles from './MagazineCardGrid.module.sass'

interface Props {
  news?: any[] // MagazineNode[]
  className?: string
}

const MagazineCardGrid = (props: Props) => {
  const { news = [], className = '' } = props

  return news?.length > 0 ? (
    <div className={`${styles.root} ${className}`}>
      <WContainer className={styles.container}>
        <div className={styles.layout}>
          {news.map((n) => (
            <ArticoloCard key={n.pk} news={n} />
          ))}
        </div>
      </WContainer>
    </div>
  ) : (
    <></>
  )
}

export default MagazineCardGrid
